
import { useContext, useEffect, useState } from "react";
import {
    BuilderProjectModel,
    DeveloperProjectModel,
} from "../../models/project";
import { moneyFormatter } from "../../lib/formatters";
import { Eligibility } from "../project_conf/round_model";
import { late } from "zod";

type BidChartInfoProps = {
    accessToken: string | null | undefined;
    projectSummary: BuilderProjectModel | DeveloperProjectModel;
};

function BuilderCard() {
    return <></>;
}

export function DeveloperBidChartInfo({
    projectSummary,
}: BidChartInfoProps) {
    const [infoData, setinfoData] = useState<any>();

    console.log("veiem", projectSummary);

    useEffect(() => {
        const bestPrice = projectSummary.bids.reduce(
            (max: any, item: any) =>
                // item.response_status === "validated" as 'validate' && item.bid_amount > max ? item.bid_amount : max
                item.bid_amount > max ? item.bid_amount : max,
            0
        );

        const lowestPrice = (projectSummary as DeveloperProjectModel
        ).bid_summary?.reduce((min: any, item: any) => {
            const bidAmount = item.latest_bid?.bid_amount;
            if (bidAmount != null && !isNaN(bidAmount)) {
                return bidAmount < min ? bidAmount : min;
            }
            return min;
        }, Infinity);

        const validLowestPrice = lowestPrice === Infinity ? null : lowestPrice;

        setinfoData(() => ({
            bestCurrentBid: bestPrice,
            lowestPrice: validLowestPrice,
            latestBid: projectSummary.bidding_view?.latest.bid_amount,
            totalPotentialSaving: projectSummary.ve_summary
                ? projectSummary.ve_summary.best_savings_potential
                : 0,
        }));
    }, []);

    return (
        <div className="flex justify-left gap-x-4 ">
            <div className="grid grid-cols-[auto,1fr] gap-x-2 ">
                <div className="grid grid-cols-1 grid-rows-7 text-sm">
                    <p className="font-semibold text-gray-800">Address:</p>
                    <p className="font-semibold text-gray-800">Stage:</p>
                    <p className="font-semibold text-gray-800">Sector:</p>
                    <p className="font-semibold text-gray-800">GSF:</p>
                    <p></p>
                    {/*<p className="font-semibold text-gray-800">*/}
                    {/*    Current Lowest bid:*/}
                    {/*</p>*/}
                    <p className="font-semibold text-gray-800"> Best VE:</p>
                    <p className="font-semibold text-gray-800">Total VE:</p>
                </div>

                <div className="grid grid-cols-1 grid-rows-7">
                    <span className="font-medium text-gray-600 ml-2 text-sm text-ellipsis overflow-hidden whitespace-nowrap">
                        {String(projectSummary?.address.address)}
                    </span>
                    <span className="font-medium text-gray-600 ml-2 text-ellipsis overflow-hidden whitespace-nowrap">
                        {projectSummary.stage}
                    </span>
                    <span className="font-medium text-gray-600 ml-2 text-ellipsis overflow-hidden whitespace-nowrap">
                        {projectSummary.sector}
                    </span>
                    <span className="font-medium text-gray-600 ml-2 text-ellipsis overflow-hidden whitespace-nowrap">
                        {projectSummary.gsf}
                    </span>
                    <span></span>
                    {/*<span className="font-medium text-gray-600 ml-2">*/}
                    {/*    /!* {infoData?.lowestPrice ? moneyFormatter.format(infoData?.lowestPrice) : ''} *!/*/}
                    {/*    {moneyFormatter.format(infoData?.lowestPrice)}*/}
                    {/*</span>*/}
                    {/* <span className="font-medium text-gray-600 ml-2">
                            {moneyFormatter.format(builderData?.latestBid)}
                            </span> */}
                    <span className="font-medium text-gray-600 ml-2">
                        {moneyFormatter.format(
                            projectSummary?.ve_summary?.best_savings_potential
                        )}
                    </span>
                    <span className="font-medium text-gray-600 ml-2">
                        {moneyFormatter.format(
                            (projectSummary as DeveloperProjectModel).ve_summary
                                ?.total_savings_suggested
                        )}
                    </span>
                </div>
            </div>
        </div>
    );
}

const BuilderBidChartInfo = ({
    accessToken,
    projectSummary,
}: BidChartInfoProps) => {

    const [builderInfo, setBuilderInfo] = useState<any>();

    console.log(projectSummary, "veiem");

    useEffect(() => {
        const latest = projectSummary.bids.find(
            (item) => item.is_latest === true
        );

        const bestCurrentBid = projectSummary.bids.reduce((acc, currVal) => {
            return currVal.bid_amount > acc ? currVal.bid_amount : acc;
        }, 0);

        setBuilderInfo({
            latestBid: latest,
            bestCurrentBid: bestCurrentBid,
        });
    }, []);
    
    return (
        <div className=" w-full grid grid-cols-1 xl:grid-cols-2 gap-y-5 gap-x-3">
            <div className="space-y-4">
                <div className="flex  items-start">
                    <p className="font-semibold text-gray-800 w-16 flex-shrink-0">
                        Address:
                    </p>
                    <span className="font-medium text-gray-600 ml-2 break-all text-ellipsis overflow-hidden whitespace-nowrap">
                        {String(projectSummary?.address.address)}
                    </span>
                </div>

                <div className="flex items-start">
                    <p className="font-semibold text-gray-800 w-16 ">Stage:</p>
                    <span className="font-medium text-gray-600 ml-2 break-all text-ellipsis overflow-hidden whitespace-nowrap">
                        {projectSummary.stage}
                    </span>
                </div>

                <div className="flex items-start">
                    <p className="font-semibold text-gray-800 w-16">Sector:</p>
                    <span className="font-medium text-gray-600 ml-2 break-all text-ellipsis overflow-hidden whitespace-nowrap">
                        {projectSummary.sector}
                    </span>
                </div>

                <div className="flex items-start">
                    <p className="font-semibold text-gray-800 w-16">GSF:</p>
                    <span className="font-medium text-gray-600 ml-2 text-ellipsis overflow-hidden whitespace-nowrap">
                        {projectSummary.gsf}
                    </span>
                </div>
            </div>

            <div className="space-y-4">
                <div className="flex items-start">
                    <p className="font-semibold text-gray-80 w-300lg:">
                         Auction Status:
                    </p>
                    <p className="font-medium text-gray-600 ml-2">
                        {(projectSummary as BuilderProjectModel)?.current_round
                            ?.eligibility === Eligibility.Closed
                            ? "The Project is not accepting Bids at this time"
                            : "The project is accepting Bids"}
                    </p>
                </div>

                <div className="flex items-start">
                    <p className="font-semibold text-gray-800 w-30 lg:w-28 ">
                        Current round:
                    </p>
                    <p className="font-medium text-gray-600 ml-2">
                        {
                            (projectSummary as BuilderProjectModel)
                                ?.current_round?.name
                        }
                    </p>
                </div>

                <div className="flex items-start">
                    <p className="font-semibold text-gray-800 w-30 lg:w-28 ">Latest bid:</p>
                    <p className="font-medium text-gray-600 ml-2">
                    { moneyFormatter.format(builderInfo?.latestBid?.bid_amount)}
                    </p>
                </div>

                <div className="flex items-start">
                    <p className="font-semibold text-gray-800 w-30 lg:w-28 ">
                        Best current bid:
                    </p>
                    <p className="font-medium text-gray-600 ml-2">
                        {moneyFormatter.format(builderInfo?.bestCurrentBid)}
                    </p>
                </div>

                <div className="flex items-start">
                    <p className="font-semibold text-gray-800 w-30 lg:w-28 ">
                        Total Potential Savings:
                    </p>
                    <p className="font-medium text-gray-600 ml-2">
                        
                        {moneyFormatter.format(
                            projectSummary?.ve_summary?.best_savings_potential
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BuilderBidChartInfo;
